"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGoToUserWarningsReport = void 0;
const moment_1 = __importDefault(require("moment"));
const routeUtil_1 = __importDefault(require("../routeUtil"));
const useRememberTableConfig_1 = require("./useRememberTableConfig");
const useGoToUserWarningsReport = (selectedMonth) => {
    const rememberTableConfig = (0, useRememberTableConfig_1.useRememberTableConfig)('workspaceReportWarningsTable');
    const goToUserWarningsReport = (userIds) => {
        const month = (0, moment_1.default)(selectedMonth, 'YYYY-MM');
        rememberTableConfig([['employees', userIds], ['period', { start: month.startOf('month').toDate(), end: month.endOf('month').toDate() }]]);
        routeUtil_1.default.navigate('/backoffice/reports/warnings');
    };
    return goToUserWarningsReport;
};
exports.useGoToUserWarningsReport = useGoToUserWarningsReport;
